var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkedInOutlined = function SvgLinkedInOutlined(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63934 11.3279H1.49182V31H7.63934V11.3279ZM8.19263 4.56557C8.19587 4.10057 8.10747 3.63948 7.93251 3.20862C7.75756 2.77777 7.49944 2.38559 7.1729 2.05451C6.84637 1.72341 6.45783 1.45986 6.02945 1.27893C5.60108 1.09801 5.14124 1.00322 4.67624 1H4.56557C3.61993 1 2.71301 1.37567 2.04433 2.04433C1.37567 2.71302 1 3.61994 1 4.56557C1 5.51123 1.37567 6.41815 2.04433 7.08684C2.71301 7.7555 3.61993 8.13117 4.56557 8.13117C5.03063 8.1426 5.49337 8.0623 5.92735 7.89483C6.36135 7.72739 6.75811 7.47605 7.09494 7.15521C7.43177 6.83437 7.70209 6.45028 7.89043 6.02493C8.07877 5.59958 8.18146 5.14129 8.19263 4.67625V4.56557ZM31 19.0493C31 13.1353 27.2377 10.8361 23.5001 10.8361C22.2763 10.7748 21.0577 11.0355 19.966 11.5921C18.8746 12.1486 17.9478 12.9817 17.2787 14.0082H17.1065V11.3279H11.3279V31H17.4754V20.5368C17.3866 19.4654 17.7241 18.4019 18.4147 17.5778C19.1053 16.7536 20.0933 16.2353 21.1639 16.1354H21.3976C23.3525 16.1354 24.8033 17.3648 24.8033 20.463V31H30.9509L31 19.0493Z",
    stroke: "var(--hyperlink )",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedInOutlined, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedInOutlined.ed26f392.svg";
export { ForwardRef as ReactComponent };